import Header from '@/components/elements/Header/Header';
import Alert from '@/components/elements/notifications/Alert/Alert';
import { LoadingIcon } from '@/components/icons';
import Icon from '@/components/icons/Icon';
import PickPaymentMethod from '@/components/modules/checkout/PickPaymentMethod/PickPaymentMethod';
import { COUPON_PAYMENT_METHOD } from '@/constants/checkout';
import { _s, _t } from '@/locale';
import { TriggerSource } from '@/types/analytics';
import { CheckoutSummary, CouponMethod, SelectedPaymentMethod } from '@/types/checkout';
import { Fragment } from 'react/jsx-runtime';
import { UseCheckoutModalManagerResult } from '../CheckoutModal/CheckoutModal.hooks';

export type PromotedPaymentMethodsProps = {
  summary: CheckoutSummary;
  selectedPaymentMethod: SelectedPaymentMethod;
  onChangePaymentMethod: (method: SelectedPaymentMethod | CouponMethod) => void;
  useHighlighted?: boolean;
  error?: boolean;
  loading?: boolean;
  isOnlinePaymentRequiredCustomer?: boolean;
  isGiftcardCheckout?: boolean;
} & Omit<UseCheckoutModalManagerResult, 'onClose'> & { triggerSource: TriggerSource };

const PromotedPaymentMethods = ({
  summary,
  selectedPaymentMethod,
  triggerSource,
  onChangePaymentMethod,
  onOpen,
  isGiftcardCheckout,
  useHighlighted = false,
  error = false,
  loading = false,
  isOnlinePaymentRequiredCustomer = false,
}: PromotedPaymentMethodsProps) => {
  const handleChangePaymentMethod = (method: SelectedPaymentMethod | CouponMethod) => {
    if (method.type === COUPON_PAYMENT_METHOD.GIFTCARD) {
      onOpen('applyGiftcard');
      return;
    }
    if (method.type === COUPON_PAYMENT_METHOD.VALUECARD) {
      onOpen('applyValuecard');
      return;
    }
    if (method.type === COUPON_PAYMENT_METHOD.WELLNESSCARD) {
      onOpen('applyWellnesscard');
      return;
    }

    onChangePaymentMethod(method);
  };

  return (
    <Fragment>
      <div className="px-lg pt-md gap-lg flex flex-col">
        <Header size="lg" label={_s('choosePaymentMethod')} />
        {error && (
          <Alert
            leftSlot={
              <div className="flex items-start justify-start">
                <Icon variant="error" color="fg_negative" />
              </div>
            }
            verticalAlign="top"
            variant="warning"
            body={
              <span className="text-m text-fg_primary">
                {_t(`components.templates.checkout.SelectPaymentOptions.error`)}
              </span>
            }
          />
        )}
      </div>

      {loading ? (
        <LoadingIcon style={{ margin: 'auto', width: 40 }} />
      ) : (
        <div className="px-lg">
          <PickPaymentMethod
            triggerSource={triggerSource}
            onPaymentSelected={handleChangePaymentMethod}
            summary={summary}
            selectedPaymentMethod={selectedPaymentMethod}
            methodsVisible={3}
            useHighlighted={useHighlighted}
            isOnlinePaymentRequiredCustomer={isOnlinePaymentRequiredCustomer}
            isGiftcardCheckout={isGiftcardCheckout}
          />
        </div>
      )}
    </Fragment>
  );
};

export default PromotedPaymentMethods;
